import type { PreparationCard } from "../types/cards";

export const preparationCards: PreparationCard[] = [
  {
    id: "prep_001",
    title: "Community College Degree",
    description: "Two years of focused study.",
    conceptExplanation: "A two-year degree costs less than a four-year university but still unlocks higher-paying jobs. Return on investment can be faster — you enter the workforce sooner with less debt.",
    deck: "preparation",
    illustrationKey: "purple",
    grantsIcons: ["degree"],
    wlbCost: 3,
    oneTimeBonus: 0,
  },
  {
    id: "prep_002",
    title: "Electrician Certification",
    description: "Complete a trade apprenticeship.",
    conceptExplanation: "Trade certifications are in high demand. Electricians earn median salaries above many college graduates — with no student debt and immediate employment.",
    deck: "preparation",
    illustrationKey: "yellow",
    grantsIcons: ["trade_cert"],
    wlbCost: 2,
    oneTimeBonus: 10,
  },
  {
    id: "prep_003",
    title: "Online Coding Bootcamp",
    description: "12 weeks of intensive learning.",
    conceptExplanation: "Bootcamps are fast and cheaper than degrees. They grant a skill badge but not a full degree — some jobs require both. A great way to change careers quickly.",
    deck: "preparation",
    illustrationKey: "teal",
    grantsIcons: ["skill_badge"],
    wlbCost: 2,
    oneTimeBonus: 0,
  },
  {
    id: "prep_004",
    title: "Networking Event",
    description: "Meet people in your industry.",
    conceptExplanation: "A strong professional network can multiply income. Many jobs are filled through connections, not job boards. Who you know is as important as what you know.",
    deck: "preparation",
    illustrationKey: "pink",
    grantsIcons: ["network"],
    wlbCost: 1,
    oneTimeBonus: 5,
  },
  {
    id: "prep_005",
    title: "Spanish Language Course",
    description: "Learn to speak a second language.",
    conceptExplanation: "Bilingual workers earn 10–15% more on average. Speaking Spanish opens doors across Latin America, the US, and Europe — a hugely valuable career skill.",
    deck: "preparation",
    illustrationKey: "teal",
    grantsIcons: ["language"],
    wlbCost: 2,
    oneTimeBonus: 0,
  },
  {
    id: "prep_006",
    title: "Leadership Workshop",
    description: "Build management and team skills.",
    conceptExplanation: "Leadership skills are consistently among the highest-valued by employers. Managers and team leads earn significantly more than individual contributors in most fields.",
    deck: "preparation",
    illustrationKey: "green",
    grantsIcons: ["leadership"],
    wlbCost: 1,
    oneTimeBonus: 5,
  },
  {
    id: "prep_007",
    title: "University Degree",
    description: "Four years of higher education.",
    conceptExplanation: "A four-year university degree opens doors to professional roles, postgraduate study, and research careers. The long-term income premium is significant — but so is the upfront cost.",
    deck: "preparation",
    illustrationKey: "purple",
    grantsIcons: ["degree"],
    wlbCost: 4,
    oneTimeBonus: 0,
  },
  {
    id: "prep_008",
    title: "Plumbing Apprenticeship",
    description: "Learn on the job with a master plumber.",
    conceptExplanation: "Apprenticeships let you earn while you learn — no student debt. Plumbing is recession-proof work because pipes always need fixing!",
    deck: "preparation",
    illustrationKey: "yellow",
    grantsIcons: ["trade_cert"],
    wlbCost: 2,
    oneTimeBonus: 8,
  },
  {
    id: "prep_009",
    title: "Design Skills Course",
    description: "Learn graphic design fundamentals.",
    conceptExplanation: "Creative skills like design are in demand across every industry. A skill badge for design can combine with other qualifications to open freelance and full-time roles.",
    deck: "preparation",
    illustrationKey: "pink",
    grantsIcons: ["skill_badge"],
    wlbCost: 2,
    oneTimeBonus: 0,
  },
  {
    id: "prep_010",
    title: "Industry Conference",
    description: "Attend and present at your field's big event.",
    conceptExplanation: "Conferences combine learning with networking. Speaking at one positions you as an expert and generates connections that can lead to jobs, clients, and partnerships.",
    deck: "preparation",
    illustrationKey: "blue",
    grantsIcons: ["network", "leadership"],
    wlbCost: 2,
    oneTimeBonus: 0,
  },
  {
    id: "prep_011",
    title: "French Immersion Program",
    description: "Three months abroad in Paris.",
    conceptExplanation: "Language immersion is the fastest way to fluency. Speaking French opens doors to Europe, Canada, and francophone Africa — markets with enormous economic activity.",
    deck: "preparation",
    illustrationKey: "teal",
    grantsIcons: ["language"],
    wlbCost: 3,
    oneTimeBonus: 0,
  },
  {
    id: "prep_012",
    title: "Data Science Certificate",
    description: "Learn to analyse and interpret data.",
    conceptExplanation: "Data literacy is one of the fastest-growing skills employers need. A data science credential commands a salary premium across almost every industry.",
    deck: "preparation",
    illustrationKey: "blue",
    grantsIcons: ["skill_badge", "degree"],
    wlbCost: 3,
    oneTimeBonus: 0,
  },
];
